import React, { useMemo, useState, useEffect } from "react";
//import {isMobile} from 'react-device-detect';
const TeenpattiCasinoBetslipWeb = ({
  showBetSlip,
  placeBetObject,
  closeBetSlipParent,
  placeBetParent,
  betErrorMessageObj,
  profileData,
}) => {
  /*console.log(showBetSlip);
    console.log(placeBetObject);*/
  //console.log("profileData in TeenpattiCasinoBetslipWeb:", profileData);
  const [stakeValue, setBetfairStakeValue] = useState({ value: "" });
  const [showBetfairProfitLossCalculation, setBetfairProfitLossCalculation] =
    useState(false);
  const [liability, setLiabilityValue] = useState(0);
  const [profit, setProfitValue] = useState(0);
  const [betErrorMessage, setBetErrorMessage] = useState("");
  const [betButtonShowLoaderShow, setButtonShowLoaderShow] = useState(false);

  const capitalizeEachWord = (str) => {
    if (!str) return "";
    return str
      .toLowerCase()
      .split(" ")
      .map((word) => {
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(" ");
  };

  const setBetfairStake = (value) => {
    if (stakeValue.value > 0) {
      let newValue = stakeValue.value + value;
      setBetfairStakeValue({ value: newValue });
    } else {
      setBetfairStakeValue({ value });
    }

    if (placeBetObject.bettype == "b") {
      let liveRate = placeBetObject.odds;
      if (liveRate > 0) {
        let liabilityNew = stakeValue.value + value;
        setLiabilityValue(liabilityNew);

        let profitNew = liveRate * liabilityNew - liabilityNew;
        setProfitValue(profitNew);
        setBetfairProfitLossCalculation(true);
      }
    } else {
      let liveRate = placeBetObject.odds;
      if (liveRate > 0) {
        let profitNew = stakeValue.value + value;
        setProfitValue(profitNew);

        let liabilityNew = liveRate * profitNew - profitNew;
        setLiabilityValue(liabilityNew);
        setBetfairProfitLossCalculation(true);
      }
    }
  };

  const closeBetSlip = () => {
    //betSlipDisplayStatus = false;
    setBetfairStakeValue({ value: "", type: "" });
    setLiabilityValue(0);
    setProfitValue(0);
    closeBetSlipParent();
    setBetErrorMessage("");
    setBetfairProfitLossCalculation(false);
  };

  const clearStake = () => {
    setBetfairStakeValue({ value: "", type: "" });
    setLiabilityValue(0);
    setProfitValue(0);
    setBetErrorMessage("");
    setBetfairProfitLossCalculation(false);
    //clearBetSlipParent();
  };

  const place_bet = () => {
    //const intervalId = setInterval(() => {
    if (stakeValue.value > 0) {
      setBetErrorMessage("");
      setButtonShowLoaderShow(true);
      //setBetButtonShow(false);
      placeBetParent(stakeValue.value, profit);
      //clearInterval(intervalId);
    }
    //}, 10000); // 1 second
  };

  useEffect(() => {
    if (betErrorMessageObj !== null && betErrorMessageObj !== undefined) {
      if (
        betErrorMessageObj.status !== null &&
        betErrorMessageObj.status !== undefined
      ) {
        if (betErrorMessageObj.status) {
          setBetErrorMessage("");
          closeBetSlip();
          setButtonShowLoaderShow(false);
          //setBetButtonShow(true);
          //betSlipDisplayStatus = false;
        } else {
          setButtonShowLoaderShow(false);
          //setBetButtonShow(true);
          setBetErrorMessage(betErrorMessageObj.message);
        }
      }
    }
  }, [betErrorMessageObj]);

  return (
    <div
      id="casinoBetslipWeb"
      className="bets mob-hide"
      style={{ display: showBetSlip == true ? "block" : "none" }}
    >
      <strong>Bet Slip </strong>
      <div className="betting-table">
        <table className="table">
          <thead>
            <tr>
              <th>Bet for</th>
              <th>Odds</th>
              <th>Stake</th>
              <th>Profit</th>
            </tr>
          </thead>
          <tbody>
            <tr
              className=" bgColorBetslip"
              style={{
                background:
                  placeBetObject.bettype === "b" ||
                  placeBetObject.bettype === "B"
                    ? "var(--theme-bg-color)"
                    : "#fce3e4"
              }}
            >
              <td>
                <span id="divteamname_casino_web">
                  {capitalizeEachWord(
                    placeBetObject.displayTeamname || placeBetObject.teamname
                  )}
                </span>
              </td>
              <td width="10%">
                <div className="quantity">
                  <input
                    type="text"
                    id="odd_casino_web"
                    name="odd_casino_web"
                    value={placeBetObject.odds}
                  />
                  <div className="quantity-nav">
                    <div className="quantity-button quantity-up">
                      <span className="fa fa-caret-up"></span>
                    </div>
                    <div className="quantity-button quantity-down">
                      <span className="fa fa-caret-down"></span>
                    </div>
                  </div>
                </div>
              </td>
              <td width="10%">
                <div className="stake">
                  <input
                    type="text"
                    id="casino_amount_web"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                    value={stakeValue.value}
                  />
                </div>
              </td>
              <td width="30%">
                <span
                  style={{
                    display: showBetfairProfitLossCalculation ? "" : "none"
                  }}
                >
                  <span id="web_profit_div_web">
                    <span id="span_profit_casino_web">{profit}</span>
                  </span>
                  <span id="span_profit_loss_gap">/ -</span>
                  <span id="mobile_lib_div_web">
                    <span id="span_liability_casino_web">{liability}</span>
                  </span>
                </span>
              </td>
            </tr>
            <tr
              className=" bgColorBetslip"
              style={{
                background:
                  placeBetObject.bettype === "b" ||
                  placeBetObject.bettype === "B"
                    ? "var(--theme-bg-color)"
                    : "#fce3e4"
              }}
            >
              <td colspan="5">
                <table
                  className="table"
                  style={{ backgroundColor: "transparent" }}
                >
                  <tbody>
                    <tr className="checknow">
                      <td>
                        <span
                          className="points stake_btn_web"
                          onClick={() =>
                            setBetfairStake(
                              profileData?.response?.stake1
                                ? profileData?.response?.stake1
                                : 100
                            )
                          }
                        >
                          {profileData?.response?.stake1
                            ? profileData?.response?.stake1
                            : 100}
                        </span>
                      </td>
                      <td>
                        <span
                          className="points stake_btn_web"
                          onClick={() =>
                            setBetfairStake(
                              profileData?.response?.stake2 ? profileData?.response?.stake2 : 200
                            )
                          }
                        >
                          {profileData?.response?.stake2 ? profileData?.response?.stake2 : 200}
                        </span>
                      </td>
                      <td>
                        <span
                          className="points stake_btn_web"
                          onClick={() =>
                            setBetfairStake(
                              profileData?.response?.stake3 ? profileData?.response?.stake3 : 500
                            )
                          }
                        >
                          {profileData?.response?.stake3 ? profileData?.response?.stake3 : 500}
                        </span>
                      </td>
                      <td>
                        <span
                          className="points stake_btn_web"
                          onClick={() =>
                            setBetfairStake(
                              profileData?.response?.stake4 ? profileData?.response?.stake4 : 1000
                            )
                          }
                        >
                          {profileData?.response?.stake4 ? profileData?.response?.stake4 : 1000}
                        </span>
                      </td>
                    </tr>
                    <tr className="checknow">
                      <td>
                        <span
                          className="points stake_btn_web"
                          onClick={() =>
                            setBetfairStake(
                              profileData?.response?.stake5 ? profileData?.response?.stake5 : 5000
                            )
                          }
                        >
                          +{profileData?.response?.stake5 ? profileData?.response?.stake5 : 5000}
                        </span>
                      </td>
                      <td>
                        <span
                          className="points stake_btn_web"
                          onClick={() =>
                            setBetfairStake(
                              profileData?.response?.stake6 ? profileData.response?.stake6 : 10000
                            )
                          }
                        >
                          +{profileData?.response?.stake6 ? profileData.response?.stake6 : 10000}
                        </span>
                      </td>
                      <td>
                        <span
                          className="points stake_btn_web"
                          onClick={() =>
                            setBetfairStake(
                              profileData?.response?.stake7 ? profileData.response?.stake7 : 20000
                            )
                          }
                        >
                          +{profileData?.response?.stake7 ? profileData.response?.stake7 : 20000}
                        </span>
                      </td>
                      <td>
                        <span
                          className="points stake_btn_web"
                          onClick={() =>
                            setBetfairStake(
                              profileData?.response?.stake8 ? profileData.response?.stake8 : 25000
                            )
                          }
                        >
                          +{profileData?.response?.stake8 ? profileData.response?.stake8 : 25000}
                        </span>
                      </td>
                    </tr>

                    <tr id="errorWebSlip">
                      <td colspan="6" className="alert-danger pr-5">
                        <span style={{ color: "red" }}>{betErrorMessage}</span>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <button
                          onClick={() => closeBetSlip()}
                          type="reset"
                          className="align-left btn btn-danger"
                          onclick="close_casino_betslip_web()"
                        >
                          <b>Close</b>
                        </button>
                      </td>
                      <td>
                        <button
                          onClick={() => clearStake()}
                          type="reset"
                          className="align-left btn btn-warning"
                          onclick="close_casino_betslip_web()"
                        >
                          <b>Clear</b>
                        </button>
                      </td>
                      <td colspan="1"></td>
                      <td>
                        <div
                          onClick={() => place_bet()}
                          className="btn btn-primary ld-over"
                          style={{
                            cursor: "pointer",
                            display: betButtonShowLoaderShow ? "none" : ""
                          }}
                          id="btn_place_bet_casino_web"
                          name="btn_place_bet_casino_web"
                        >
                          <b>Submit</b>
                          <div className="ld ld-ball ld-flip"></div>
                        </div>
                        <div
                          className="btn btn-primary ld-over running"
                          style={{
                            cursor: "pointer",
                            display: betButtonShowLoaderShow ? "" : "none"
                          }}
                          id="btn_place_bet_casino_web"
                          name="btn_place_bet_casino_web"
                        >
                          <b>Submit</b>
                          <div className="ld ld-ball ld-flip"></div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default React.memo(TeenpattiCasinoBetslipWeb);
